/*
 *  Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 *  Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { DocumentResource } from '../api/documents/documentsClient.typings';

export enum DocumentDetailsActionType {
    OPEN_REGISTRY_DOCUMENT_CARD_PAGE = 'RegistryDocumentCard/ open page',
    EXIT_REGISTRY_DOCUMENT_CARD_PAGE = 'RegistryDocumentCard/ exit page',

    FETCH_DOCUMENT_CARD_DETAILS_SUCCESS = 'RegistryDocumentCard/ fetch document card details success',
    FETCH_DOCUMENT_CARD_DETAILS_ERROR = 'RegistryDocumentCard/ fetch document card details error',
}

export const openRegistryDocumentCardAction = (documentId: string) =>
    createAction(DocumentDetailsActionType.OPEN_REGISTRY_DOCUMENT_CARD_PAGE, documentId);

export const exitRegistryDocumentCardAction = () =>
    createAction(DocumentDetailsActionType.EXIT_REGISTRY_DOCUMENT_CARD_PAGE);

export const fetchDocumentCardDetailsSuccessAction = (payload: DocumentResource) =>
    createAction(DocumentDetailsActionType.FETCH_DOCUMENT_CARD_DETAILS_SUCCESS, payload);

export const fetchDocumentCardDetailsErrorAction = (notification: Notification) =>
    createAction(DocumentDetailsActionType.FETCH_DOCUMENT_CARD_DETAILS_ERROR, { notification });

export type DocumentDetailsAction =
    | ReturnType<typeof openRegistryDocumentCardAction>
    | ReturnType<typeof exitRegistryDocumentCardAction>
    | ReturnType<typeof fetchDocumentCardDetailsSuccessAction>
    | ReturnType<typeof fetchDocumentCardDetailsErrorAction>;
